<template>
  <div>
    <div class="label-title">
      <span v-if="!isView" class="require">*</span>
      {{title}}
      <el-upload
        v-if="!isView"
        class="upload-group flex"
        ref="upload-add"
        action="upload"
        :disabled="uploading"
        :show-file-list="false"
        :before-upload="getUploadInfo"
        :http-request="handleUpload"
        accept="*"
      >
        <el-button :loading="uploading" type="primary">选择文件</el-button>
      </el-upload>
    </div>
    <el-table :data="fileList" border height="350" style="width: 100%">
      <el-table-column
        prop="fileName"
        label="附件名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="createUserName" width="160" label="上传人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="updateTime" width="150" label="上传时间" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="preview(scope.row)"
            >预览</el-button
          >
          <el-button type="text" size="mini" @click="download(scope.row)"
            >下载</el-button
          >
          <el-button
            v-if="!isView"
            type="text"
            size="mini"
            @click="del(scope.$index, scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { OSS_FILE_MAX_SIZE } from '../../../constant/constant.js'
import { ossUpload } from "../../../api/uploadAndDownload.js";
import { filePreview } from "@/utils/filePreview.js";
import { deletePersonFile } from "../../../api/performManage.js";
export default {
  name: "fileOperate",
  props: {
    isView: {
      type: Boolean,
      default: false,
    },
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      uploading: false,
    };
  },
  methods: {
    // 文件名处理
    handleFileNameAndSize(file) {
      const index = file.name.lastIndexOf(".");
      const originName = file.name
        .substring(0, index)
        .replace(
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/gi,
          ""
        )
        .replace(/\s+/g, "");
      const originNameType = file.name.substring(index, file.length);
      // this.uploadName = originName + '_' + new Date().getTime() + originNameType;
      this.uploadName = originName + originNameType;
      this.contentLength = file.size;
    },
    getUploadInfo(file) {
      this.handleFileNameAndSize(file);
      // 不允许上传不可预览格式文件
      let uploadTypeReg =
        /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga|doc|docx|xls|xlsx|ppt|pptx|pdf|txt)$/;
      let fileType = file.name.slice(file.name.lastIndexOf("."));

      if (!uploadTypeReg.test(fileType.toLowerCase())) {
        this.$message.warning("不支持上传" + fileType + "格式文件");
        return false;
      }
      if (file.size > 1024 * 1024 * OSS_FILE_MAX_SIZE) {
        this.$message.warning(`上传文件不能大于${OSS_FILE_MAX_SIZE}MB`);
        return false;
      }
    },
    preview(row) {
      const fileObj = {
        fileName: row.fileName,
        fileId: row.fileId || row.id,
        fileUrl: row.fileUrl,
      };
      filePreview(fileObj);
    },
    download(row) {
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = row.fileUrl;
      a.target = "_blank";
      a.download = row.fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    del(idx, id) {
      if (id) {
        //有id就是已经提交过的附件，否则就是没提交过
        // deletePersonFile({ id }).then(res => {
        //     if (res && +res.code === 0) {
        //         this.fileList.splice(idx, 1)
        //     }
        // })
        this.$emit("del", id);
      }
      this.fileList.splice(idx, 1);
    },
    handleUpload(uploadData) {
      this.uploading = true;
      const file = new File([uploadData.file], uploadData.file.name, {
        type: uploadData.file.type,
      });
      ossUpload(file, { bucket: "srm", publicRead: 1, businessKey: "" })
        .then((res) => {
          if (res && +res.code === 0) {
            res.data.fileUrl = decodeURIComponent(res.data.downUrl);
            // // 0627 OSS版本升级，使用当前时间戳作id
            res.data.fileId = (new Date()).getTime();
            res.data.fileName = file.name
            res.data.type = file.type
            this.fileList.push(res.data);
            // this.$emit('uploadSuccess', { data: res, flag: this.flag });
          }
        })
        .finally(() => {
          this.uploading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.label-title {
    margin: 10px 0;

    .require {
        color: red;
    }

    button {
        margin-left: 20px;
    }

    .upload-group {
        display: inline-block;
    }
}
</style>
